import { render, staticRenderFns } from "./startPlaceholder-editor.vue?vue&type=template&id=09abf3bc&scoped=true"
import script from "./startPlaceholder-editor.vue?vue&type=script&lang=js"
export * from "./startPlaceholder-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09abf3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09abf3bc')) {
      api.createRecord('09abf3bc', component.options)
    } else {
      api.reload('09abf3bc', component.options)
    }
    module.hot.accept("./startPlaceholder-editor.vue?vue&type=template&id=09abf3bc&scoped=true", function () {
      api.rerender('09abf3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/startPlaceholder-editor.vue"
export default component.exports